import { memo } from 'react';
import { Box, Text } from '@betty/moonlight';

function StatusVipInstructions() {
  return (
    <Box
      flex={1}
      backgroundColor="mutedBackground"
      alignItems="center"
      padding="space-300"
      borderRadius="radius-200"
    >
      <Text
        variant="caption-semi"
        gradient="darkSurfaceStatusVip"
        locNS="status"
        locKey="Vip"
        textAlign="center"
      />
      <Text
        variant="caption"
        color="darkSurfaceTertiary"
        locNS="status"
        locKey="vip_instructions_message_a"
        textAlign="center"
      />
      <Text
        variant="caption"
        color="darkSurfaceTertiary"
        locNS="status"
        locKey="vip_instructions_message_b"
        textAlign="center"
      />
    </Box>
  );
}

export default memo(StatusVipInstructions);
